import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import make_translations from "@pdfking/workflow/utils/make_translations"

export const UnavailableAlert = CreateRenderFunction({
  computed: {
    translations: () => make_translations("errors"),
  },
  render() {
    return (
      <div class="alert alert-danger m-0">
        {this.translations.errors.BROWSER_ERROR}
      </div>
    )
  },
})
